import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { InvoiceInitialState } from './invoices.types';
import { InvoicesKey } from './invoices.const';
import { fetchProjectInvoicesData } from './invoices.thunks';
import { DataState } from '../../types/asyncData';
import { InvoiceState } from '../../features/invoices/Invoices.const';

const initialState: InvoiceInitialState = {
  invoices: {
    state: DataState.Idle,
    data: null,
  },
  areFiltersApplied: false,
  filterBy: { invoiceState: InvoiceState.OVERDUE, projectNames: [] },
  isFilterOpen: false,
};

export const invoicesSlice = createSlice({
  name: InvoicesKey,
  initialState,
  reducers: {
    setFilterByInvoiceState: (
      state,
      { payload }: PayloadAction<InvoiceState>,
    ) => {
      const isOverdueWithoutProjects =
        payload === InvoiceState.OVERDUE &&
        state.filterBy.projectNames.length === 0;

      state.areFiltersApplied = !isOverdueWithoutProjects;
      state.filterBy.invoiceState = payload;
    },
    setFilterByProjectName: (state, { payload }: PayloadAction<string>) => {
      if (!state.filterBy.projectNames.includes(payload)) {
        state.filterBy.projectNames.push(payload);
        state.areFiltersApplied =
          state.filterBy.projectNames.length > 0 ||
          state.filterBy.invoiceState !== InvoiceState.OVERDUE;
      }
    },
    removeProjectFromFilter: (state, { payload }: PayloadAction<string>) => {
      state.filterBy.projectNames = state.filterBy.projectNames.filter(
        (x) => x !== payload,
      );
      state.areFiltersApplied =
        state.filterBy.projectNames.length > 0 ||
        state.filterBy.invoiceState !== InvoiceState.OVERDUE;
    },
    resetFilters: (state) => {
      state.filterBy = initialState.filterBy;
      state.areFiltersApplied = false;
    },
    openFilter: (state) => {
      state.isFilterOpen = true;
    },
    closeFilter: (state) => {
      state.isFilterOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectInvoicesData.pending, (state) => {
        state.invoices = {
          state: DataState.Pending,
          data: null,
        };
      })
      .addCase(fetchProjectInvoicesData.fulfilled, (state, { payload }) => {
        state.invoices = {
          state: DataState.Fulfilled,
          data: payload,
        };
      })
      .addCase(fetchProjectInvoicesData.rejected, (state) => {
        state.invoices = {
          state: DataState.Rejected,
          data: null,
          error: {
            message: 'Oops. Something went wrong. :(',
          },
        };
      });
  },
});
